import {
  ALL_SUPPORTED_UPDATE_ACTIONS_TYPES,
  INTERACTION_TYPE_FIELD,
  OPERATION_TYPE_FIELD_DICTIONARY,
} from '../constants/editor.constants';
import { SOURCE_TYPES } from '../constants/form-manager.constants';
import { UPDATE_RULES_SUPPORTED_TYPES } from '../constants/runtime.constants';
import { getPropType } from '../utils/form-manager.utils';

export const getSource = ({ sourceType, source, dummySource }) =>
  sourceType && sourceType === SOURCE_TYPES.COLUMN
    ? ''
    : sourceType === SOURCE_TYPES.DATASOURCE
    ? dummySource
    : source ?? '';

export const getSourceMapping = ({ sourceType, sourceMapping, dummySource }) =>
  sourceType && sourceType === SOURCE_TYPES.DATASOURCE ? sourceMapping : dummySource ?? '';

export const getSourceType = ({ sourceType }) =>
  sourceType && sourceType === SOURCE_TYPES.DATASOURCE
    ? SOURCE_TYPES.DATASOURCE
    : SOURCE_TYPES.FORMULA;

export const getInteractionAction = ({ row = {} }) => ({
  ...row,
  ruleActionType: 'interaction',
  dummyType: (INTERACTION_TYPE_FIELD[row.type] || OPERATION_TYPE_FIELD_DICTIONARY[row.type]) ?? '',
  dummySource: null,
  source: null,
  sourceMapping: null,
  sourceType: null,
  target: null,
  targetType: null,
  targetDataType: null,
  dummyParameterType: row.parameterType ?? '',
});

export const getUpdateAction = ({ row = {}, ruleActionType, entityName, entityDefinition }) => ({
  ...row,
  ruleActionType,
  dummyType: OPERATION_TYPE_FIELD_DICTIONARY[row.type] ?? '',
  dummySource: row.dummySource ?? '',
  source: getSource(row),
  sourceMapping: getSourceMapping(row),
  sourceType: getSourceType(row),
  target: row.target ? row.target : entityName,
  targetType: row.targetType ? row.targetType : 'column',
  targetDataType: row.targetDataType
    ? row.targetDataType
    : getPropType(entityDefinition, row.targetMapping, 'DataType', true),
  dummyParameterType: row.parameterType ?? '',
  dummyParameter: row.parameter ?? '',
});

export const processRow = (params) => {
  return UPDATE_RULES_SUPPORTED_TYPES.includes(params.row.type)
    ? getUpdateAction(params)
    : getInteractionAction(params);
};

export const processActions = ({ rows, ruleActionType, entityName, entityDefinition }) =>
  rows.map((row) =>
    ALL_SUPPORTED_UPDATE_ACTIONS_TYPES.includes(row.type)
      ? processRow({ row, ruleActionType, entityName, entityDefinition })
      : row
  );
